import React from 'react';
import { Routes, Route } from 'react-router-dom';
import LeadAccountList from '../components/LeadAccountList';
import LeadAccountForm from '../components/LeadAccountForm';

const LeadAccountsPage = () => {
    return (
        <Routes>
            <Route path="/" element={<LeadAccountList />} />
            <Route path="/new" element={<LeadAccountForm />} />
            <Route path="/edit/:id" element={<LeadAccountForm />} />
        </Routes>
    );
};

export default LeadAccountsPage;